var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useSelector } from 'react-redux';
import { StepLoading } from './styles';
var Loading = function (_a) {
    var color = _a.color, height = _a.height, width = _a.width, delay = _a.delay, _b = _a.type, type = _b === void 0 ? "spin" : _b, className = _a.className, customStyle = _a.customStyle;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    if (!color) {
        color = theme.primaryColor.toUpperCase() === "#FFFFFF" ? theme.backgroundColor : theme.primaryColor;
    }
    return (React.createElement("div", { style: __assign({}, customStyle) },
        React.createElement(StepLoading, { type: type, color: color, height: height, width: width, delay: delay, className: className })));
};
export default Loading;
